var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Navigation } from '../../atoms/special/Navigation';
import { IconExpandDown } from '../../atoms/icons/24x24/expandDown';
import { ContentFadeStyle } from './ContentFadeStyle';
export var ContentFade = function (_a) {
    var children = _a.children, expandLabel = _a.expandLabel;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    return (_jsxs(ContentFadeStyle, __assign({ isOpen: isOpen }, { children: [_jsx("div", __assign({ className: "details-container" }, { children: children })), _jsxs("div", __assign({ className: "expand-container", onClick: function () { return setIsOpen(true); } }, { children: [_jsx(Navigation, __assign({ className: "expand-text" }, { children: expandLabel })), _jsx(IconExpandDown, {})] }))] })));
};
